import React, { useState } from 'react';
import '../App.css';
import {Link} from "react-router-dom";
import Footer from '../components/footer';
import Cubedynopic from "../assets/images/cubedynopic.png"
import Discordpic from "../assets/images/discordpic.png"
import DownIcon from "../assets/images/downicon.png"
import DownIconWhite from "../assets/images/downiconwhite.png"
import Like from "../assets/images/like.png"
import Rocketpic from "../assets/images/rocketpic.png"
import Swagpic from "../assets/images/swagpic.png"
import Unlike from "../assets/images/unlike.png"
import VideoPic from "../assets/images/videopic.png"

export default function Website(){

    const [firstlike, setFL] = useState(true)
    const [secondlike, setSL] = useState(true)
    const [thirdlike, setTL] = useState(true)
    const [fourthlike, setFL2] = useState(true)
    const [fifthlike, setFL3] = useState(true)
    const [sixthlike, setSL2] = useState(true)
    const [seventhlike, setSL3] = useState(true)
    const [eighthlike, setEL] = useState(true)
    const [ninthlike, setNL] = useState(true)

    const [show1, setShow1] = useState(false)
    const [show2, setShow2] = useState(false)
    const [show3, setShow3] = useState(false)
    const [show4, setShow4] = useState(false)
    const [show5, setShow5] = useState(false)
    const [show6, setShow6] = useState(false)

    return(
       <div class="w-full sm:w-1/3">
           <div class="w-full mt-8 flex flex-row justify-around">
               <div class="text-4xl w-5/12">
                   <p>horsey</p>
               </div>
               <Link class="w-3/12 rounded pt-1 h-8 bg-blue-700" to="/beforeSignUp">
               <div class="w-full text-white text-center font-light">
                   <p>Sign In</p>
               </div>
               </Link>
           </div>
           <div class="w-full mb-4 flex">
            <div class="w-4/12"></div>
            <div class="w-3/12">
                <p>beta</p>
            </div>
           </div>
           <div class="w-full h-8"/>
           <div class="text-3xl bg-black text-white p-6">We untangle ideas for students</div>
           <div class="w-full mt-8 flex">
           <div class="w-1/12"></div>
           <div class="w-4/12 bg-pink-200 text-center h-7"><p class="p-px">Benefit 1</p></div>
           </div>
           <div class="w-full flex">
           <div class="w-1/12"></div>
           <div class="w-10/12"><p>Companies prefer candidates who can point out solutions and not just problems.</p></div>
           </div>
           <div class="w-full flex">
            <div class="w-1/12"></div>
            <div class="w-10/12">{firstlike?<div onClick={()=>setFL(!firstlike)} class="my-2"><img src={Unlike} alt="count"/></div>:<div onClick={()=>setFL(!firstlike)} class="my-2"><img src={Like} alt="count"/> and total likes</div>}</div>
           </div>
           <div class="w-full mt-4 flex">
           <div class="w-1/12"></div>
           <div class="w-4/12 bg-pink-200 text-center h-7"><p class="p-0.5">Benefit 2</p></div>
           </div>
           <div class="w-full flex">
           <div class="w-1/12"></div>
           <div class="w-10/12"><p>If you start generating ideas in the first year imagine how easy it would be to generate ideas during the job and life.</p></div>
           </div>
           <div class="w-full flex">
            <div class="w-1/12"></div>
            <div class="w-10/12">{secondlike?<div onClick={()=>setSL(!secondlike)} class="my-2"><img src={Unlike} alt="count"/></div>:<div onClick={()=>setSL(!secondlike)} class="my-2"><img src={Like} alt="count"/> and total likes</div>}</div>
           </div>
           <div class="w-full mt-4 flex">
           <div class="w-1/12"></div>
           <div class="w-6/12 bg-blue-200 text-center h-7"><p class="py-0.5">Assuming much</p></div>
           </div>
           <div class="w-full flex">
           <div class="w-1/12"></div>
           <div class="w-10/12"><p>If you think you are already good at idea generation, why not judge your ideas with your peers? And do you think they will not get ahead in these 4 years?</p></div>
           </div>
           <div class="w-full flex">
            <div class="w-1/12"></div>
            <div class="w-10/12">{thirdlike?<div onClick={()=>setTL(!thirdlike)} class="my-2"><img src={Unlike} alt="count"/></div>:<div onClick={()=>setTL(!thirdlike)} class="my-2"><img src={Like} alt="count"/> and total likes</div>}</div>
           </div>
           <div class="w-full mt-4 flex">
           <div class="w-1/12"></div>
           <div class="w-10/12 text-4xl bg-gradient-to-r from-indigo-200 via-red-200 to-yellow-100 font-light  p-5"><p>Get skilled in idea generation</p></div>
           </div>
           <div class="mt-8 p-4 bg-[#D2FF20]">
                <div class="flex flex-row">
                    <div class="w-9/12 aone text-2xl text-center p-2">
                        HANDLING PARENTS OBJECTIONS
                    </div>
                    <div>
                        <img src={Rocketpic} alt="none" />
                    </div>
                </div>
                <div class="flex my-3"><img  onClick={()=>setShow1(!show1)} class="m-auto" src={DownIcon} alt="none"/></div>
                {show1&&<div>
                    <div class="my-8 mx-2">
                    Not every parent is same, but few of us are really scared of them.
                    </div>
                    <div class="pt-3 mb-4 ">
                    Talking to parents has some of these aspects:
                    </div>
                    
                    <div  class="flex flex-row my-1"><div class="w-1/12 text-center">1.</div> <div class="w-11/12">Building confidence that you will not neglect your studies</div></div>
                    <div  class="flex flex-row my-1"><div class="w-1/12 text-center">2.</div> <div class="w-11/12">Do you have a proper idea with known consequences of failure or Plan B, C and D</div></div>
                    <div  class="flex flex-row my-1"><div class="w-1/12 text-center">3.</div> <div class="w-11/12">Awareness about business risks and confidence in your entreprenuerial abilities</div></div>
                    <div class="my-3">Even if you are from a secure family where they give you freedom to create your own career journey, these topics may be of interest to you anyhow.</div>
                    <div class="flex"><div class="py-2 px-4 bg-green-600 shadow-xl rounded-xl text-white border-black border-2 m-auto">Talk to me</div></div>
                    <div class="text-xs my-4 text-center">Fill the form and hear from someone who can guide you to next steps.</div>
                </div>}

            </div>
            <div class="bg-[#00FFF0] mt-8 p-4">
                <div class="flex flex-row">
                    <div class="w-7/12 aone text-2xl text-center p-2">
                        CAMPUS STARTUP PROGRAM                    
                    </div>
                    <div class="mix-blend-exclusion">
                        <img src={Cubedynopic} alt="none" />
                    </div>
                </div>
                <div class="flex my-3"><img onClick={()=>setShow2(!show2)} class="m-auto" src={DownIcon} alt="none"/></div>
                {show2&&<div>
                    <div class="p-2 my-6">
                    Each month I will work with one startup around the country and submit that proposal to their own college’s startup program for evaluation.
                    </div>
                    <div class="grid grid-cols-2 text-xs gap-0 ">
                        <div class="border-black p-1 border-2">Product Thinking</div>
                        <div class="border-black p-1 border-2">Entreprenurial Mindset</div>
                        <div class="border-black p-1 border-2">Guide on Marketing and Technology</div>
                        <div class="border-black p-1 border-2">Vision and Philosophy</div>
                    </div>
                    <div class="flex my-6"><div class="py-2 px-4 rounded-xl shadow-xl bg-[#E55AB9] text-white border-black border-2 m-auto">Eager to join!</div></div>
                    <div class="text-xs text-center">Absolutely free service</div>
                </div>}

            </div>

           <div class="w-full mt-4 flex">
           <div class="w-3/12"></div>
           <div class="w-6/12 bg-pink-200 h-9"><p class="text-center pt-1 font-bold">AIM OF THE APP</p></div>
           </div>
           <div class="w-full mt-4 flex">
           <div class="w-1/12"></div>
           <div class="w-10/12"><p class="text-center">Get placements based on your idea collection over 3 years or 4 years of college.</p></div>
           </div>
           <div class="w-full flex">
            <div class="w-1/12"></div>
            <div class="w-10/12">{fourthlike?<div onClick={()=>setFL2(!fourthlike)} class="my-2"><img    src={Unlike} alt="count"/></div>:<div onClick={()=>setFL2(!fourthlike)} class="my-2"><img src={Like} alt="count"/> and total likes</div>}</div>
           </div>
           <div class="w-full flex">
           <div class="w-5/12"></div>
           <div class="w-2/12 "><p class="text-center font-bold">OR</p></div>
           </div>
           <div class="w-full  flex">
           <div class="w-1/12"></div>
           <div class="w-10/12"><p class="text-center">Start a venture from the most suitable idea when you graduate.</p></div>
           </div>
           <div class="w-full flex">
            <div class="w-1/12"></div>
            <div class="w-10/12">{fifthlike?<div onClick={()=>setFL3(!fifthlike)} class="my-2"><img src={Unlike} alt="count"/></div>:<div onClick={()=>setFL3(!fifthlike)} class="my-2"><img src={Like} alt="count"/> and total likes</div>}</div>
           </div>
           <div class="w-full flex">
           <div class="w-5/12"></div>
           <div class="w-2/12 "><p class="text-center font-bold">OR</p></div>
           </div>
           <div class="w-full flex">
           <div class="w-1/12"></div>
           <div class="w-10/12"><p class="text-center">Sell your idea collection for lakhs of rupees at the end of college</p></div>
           </div>
           <div class="w-full flex">
            <div class="w-1/12"></div>
            <div class="w-10/12">{sixthlike?<div onClick={()=>setSL2(!sixthlike)} class="my-2"><img src={Unlike} alt="count"/></div>:<div onClick={()=>setSL2(!sixthlike)} class="my-2"><img src={Like} alt="count"/> and total likes</div>}</div>
           </div>
           <div class="w-full mt-4 flex">
           <div class="w-1/12"></div>
           <div class="w-10/12 text-4xl font-light bg-gradient-to-r from-indigo-200 via-red-200 to-yellow-100 p-5"><p>Graduate from university with an idea resume.</p></div>
           </div>
           <div class="bg-[#F5E127] mt-8 p-4">
               <div>
                   <div class="text-xl text-center">#lessthan8pointer</div>
                   <div class="text-center font-bold">JUN-JULY-AUG</div>
                   <div class="text-3xl text-center">We celebrate the swag</div>
                   <div class="flex my-3"><img onClick={()=>setShow3(!show3)} class="m-auto" src={DownIcon} alt="none"/></div>    
                </div>
               {show3&&<div>
                   <img class="m-4"src={Swagpic}></img>
                   <div class="text-xl">Share on social media and tag us.</div>
                </div>
                }
            </div>
           <div class="bg-[#F56527] text-white mt-8 p-4">
               <div>
                   <div class="text-3xl text-center">#hugfailure</div>
                   <div class="text-center font-bold">ALL YEAR LONG</div>
                   <div class="text-3xl text-center">Risky business</div>
                   <div class="flex my-3"><img onClick={()=>setShow4(!show4)} class="m-auto" src={DownIconWhite} alt="none"/></div>
               </div>
               {show4&&<div>
                   <div class="p-8 atwo text-lg bg-white lowercase text-black my-6">UPLOAD A VIDEO OF ANY OF THE TIMES YOU TRIED BUT DID NOT SUCCED - AND TELL US what did you tell yourslef to move ahead</div>
                   <div class="my-6">Share with us the link  or tag us and we have space on our insta every week </div>
                   <img src={VideoPic} alt="none"/>
               </div>}
            </div>
           
           <div class="w-full mt-4 flex">
           <div class="w-2/12"></div>
           <div class="w-7/12 bg-pink-200 h-9"><p class="text-center pt-1 font-bold">WHY SHOULD I CARE</p></div>
           </div>
           <div class="w-full mt-4 flex">
           <div class="w-1/12"></div>
           <div class="w-10/12"><p>The journey is most important, and in these 4 years somebody will learn faster and somebody else will learn faster later. But more importantly everyone will grow.</p></div>
           </div>
           <div class="w-full mt-4 flex">
           <div class="w-1/12"></div>
           <div class="w-10/12"><p>When was the last time you got excited about something on campus digitally? This app gives you talking points on the most creative ideas that may come out. </p></div>
           </div>
           <div class="w-full mt-4 flex">
           <div class="w-1/12"></div>
           <div class="w-10/12"><p>The competition is ON. Start by being the best in class, then branch, then batch, then college.</p></div>
           </div>
           <div class="w-full flex">
            <div class="w-1/12"></div>
            <div class="w-10/12">{seventhlike?<div onClick={()=>setSL3(!seventhlike)} class="my-2"><img src={Unlike} alt="count"/></div>:<div onClick={()=>setSL3(!seventhlike)} class="my-2"><img src={Like} alt="count"/> and total likes</div>}</div>
           </div>
           <div class="w-full mt-4 flex"></div>
           <div class="w-full flex">
           <div class="w-1/12"></div>
           <div class="w-10/12 text-4xl bg-gradient-to-r from-indigo-200 via-red-200 to-yellow-100 font-light  p-5"><p>Be the campus star with the best idea resume on campus</p></div>
           </div>
           <div class="bg-[#FF0000] mt-8 p-4">
               <div>
                   <div class="text-2xl text-left text-white">Our relationship is</div>
                   <div class="text-left font-bold text-6xl">Red</div>
                   <div class="flex mt-9 my-3"><img onClick={()=>setShow5(!show5)} class="m-auto" src={DownIconWhite} alt="none"/></div>
               </div>
               {show5&&<div class={`${show5&&'transition duration-500 ease-in-out hover:bg-green-400 transform hover:-translate-y-1'}`}>
                   <div class="p-3 text-white text-2xl ">Already having expectations is </div>
                   <div class="flex w-full"><div class="m-auto bg-[#00FF19] p-3">GREEN HERE</div></div>
                   <div class="p-5">If you have ever wanted some app for college, let us know now</div>
                   <textarea class="w-full p-3 h-32" placeholder="type here..."/>
                  <div class="flex my-3"> <button class="m-auto bg-black py-2 px-4 rounded-xl shadow-xl text-white">TELL US IN ADVANCE</button> </div>
                   <img/>
               </div>}
            </div>
           <div class="w-full mt-4 flex">
           <div class="w-1/12"></div>
           <div class="w-10/12 bg-pink-200 h-16 text-center font-bold"><p class="pt-1 pb-px">I’M SMART</p><p>IS THERE A HACK FOR ME</p></div>
           </div>
           <div class="w-full mt-4 flex">
           <div class="w-1/12"></div>
           <div class="w-10/12"><p>Not just your idea generation skill are at test, but your <span class="font-bold">selling</span> and <span class="font-bold">negotiation</span> skills.  </p></div>
           </div>
           <div class="w-full mt-4 flex">
           <div class="w-1/12"></div>
           <div class="w-10/12"><p>The ones who understand will not sell their ideas for thousands but hundreds.</p></div>
           </div>
           <div class="w-full flex">
            <div class="w-1/12"></div>
            <div class="w-10/12">{eighthlike?<div onClick={()=>setEL(!eighthlike)} class="my-2"><img src={Unlike} alt="count"/></div>:<div  onClick={()=>setEL(!eighthlike)} class="my-2"><img src={Like} alt="count"/> and total likes</div>}</div>
           </div>
           <div class="w-full mt-4 flex">
           <div class="w-1/12"></div>
           <div class="w-10/12 text-4xl bg-gradient-to-r from-indigo-200 via-red-200 to-yellow-100 font-light  p-5"><p>That’s not all. Buy/Sell ideas from others as a barter or for money</p></div>
           </div>

           <div class="bg-[#434EE4] text-white mt-8 p-4">
               <div>
                   <div class="flex"><img class="m-auto" src={Discordpic} alt="none"/></div>
                   <div class="text-xl text-center ">A place where friends are</div>
                   <div class="flex mt-9 my-3"><img onClick={()=>setShow6(!show6)} class="m-auto" src={DownIconWhite} alt="none"/></div>
               </div>
               {show6&&<div>
                    <div class="px-6 my-4">You have to complete one of the task on this or the Signup page to get access</div>
                    <div class="px-3">Your Email</div>
                    <div><input class="text-black px-3 mx-3 my-3 h-10 w-11/12"/></div>
                    <div class="px-3">What you did (And we will verify)</div>
                    <div><textarea class="text-black mx-3 p-3 my-3 w-11/12 h-40" placeholder='type here...'></textarea></div>
                    <button class="mx-2 px-4 py-2 rounded-2xl bg-white text-[#434EE4]">SUBMIT</button>
               </div>}
            </div>
           <div class="w-full mt-4 flex">
           <div class="w-3/12"></div>
           <div class="w-6/12 bg-pink-200 h-9 text-center font-bold"><p class="pt-1">THE CHALLENGE</p></div>
           </div>
           <div class="w-full mt-4 flex">
           <div class="w-2/12"></div>
           <div class="w-8/12"><p>Number of ideas matter as well as quality of collection. Make each idea on your resume count as a win.</p></div>
           </div>
           <div class="w-full flex">
            <div class="w-2/12"></div>
            <div class="w-8/12">{ninthlike?<div onClick={()=>setNL(!ninthlike)}  class="my-2"><img src={Unlike} alt="count"/></div>:<div onClick={()=>setNL(!ninthlike)} class="my-2"><img src={Like} alt="count"/> and total likes</div>}</div>
           </div>
           <div class="h-12"></div>
           <div class="w-full grid grid-cols-1">
               <div class="w-10/12 m-auto text-center">Get updates on happenings:</div>
               <div class="w-10/12 m-auto"><input class="border-2 my-4 border-blue-700 w-full h-12 p-2"/></div>
               <div class="w-10/12 m-auto"><button class="text-center bg-blue-700 text-white w-full px-4 py-2">SUBSCRIBE</button></div>
               <div class="my-6 text-center">or</div>
               <div class="w-10/12 m-auto"><button class="text-center bg-blue-700 text-white w-full px-8 py-2">SIGNUP</button></div>
           </div>
           <div class="w-full mt-8 text-4xl bg-pink-800 font-light text-white p-10"><p>The best idea resume is one of the most challenging act you’ll do</p></div>
           <div class="h-20"></div>
           <div className="h-4"></div>
            <div className="h-4"></div>
            <Footer/>
           <div class="text-xs w-full box-border  p-2 border-2 border-black fixed bottom-0 bg-white flex-row flex justify-evenly">
               <div class="">
               <div>Proposal Likes: 0/9</div>
               <div>Average Likes: 0/9</div>
               </div>
           </div>

       </div>
    )
}